module.exports = __webpack_public_path__ + "static/media/server_down.45c30ff2.svg";